module.exports = __webpack_public_path__ + "static/media/ZW.bd54e200.svg";